import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; //where we want to store our reducer

import userReducer from "./user/user-reducer";
import adminReducer from "./admin/admin-reducer";
import taskReducer from "./tasks/task-reducer";
import searchReducer from "./search/search.reducer";
import projectReducer from "./projects/project-reducer";
import filterReducer from "./filters/filter-reducer";
import sortReducer from "./sort/sort-reducer";
import authReducer from "./auth/auth-reducer";
import notifications from "./notifications";
import rolesReducer from "./admin/roles/roles-reducer";
import departmentReducer from "./departments/department-reducer";
import groupReducer from "./groups/group-reducer";
import usersReducer from "./users/users-reducer";
import templateReducer from "./templates/template-reducer";
import templateTaskReducer from "./templates-tasks/template-task-reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "currentUser",
    "search",
    "filters",
    "sort",
    "projects",
    "tasks",
    "auth",
  ],
};

const projectsGroupPersistConfig = {
  key: "projects",
  storage,
  whitelist: ["groupProjectsBy"],
};

const tasksGroupPersistConfig = {
  key: "tasks",
  storage,
  whitelist: ["groupTasksBy"],
};

const rootReducer = combineReducers({
  currentUser: userReducer,
  admin: adminReducer,
  projects: (projectsGroupPersistConfig, projectReducer),
  tasks: (tasksGroupPersistConfig, taskReducer),
  search: searchReducer,
  filters: filterReducer,
  sort: sortReducer,
  auth: authReducer,
  notifications: notifications?.length === 0 ? null : notifications,
  roles: rolesReducer,
  departments: departmentReducer,
  groups: groupReducer,
  users: usersReducer,
  templates : templateReducer,
  templateTasks : templateTaskReducer
});

export default persistReducer(persistConfig, rootReducer);
